// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b5f3aa29","455":"cd6900ab","977":"01172a94"}[chunkId] + ".chunk.js";
};